import { render, staticRenderFns } from "./ProjectCategoryInput.vue?vue&type=template&id=36e7b1fd&scoped=true"
import script from "./ProjectCategoryInput.vue?vue&type=script&lang=js"
export * from "./ProjectCategoryInput.vue?vue&type=script&lang=js"
import style0 from "./ProjectCategoryInput.vue?vue&type=style&index=0&id=36e7b1fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e7b1fd",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QItemSection,QIcon,QItemLabel});
